import { useState } from 'react';
import { Grid2 as Grid, Button, Accordion, AccordionSummary, AccordionDetails, Typography, Tooltip, IconButton } from '@mui/material';
import { ExpandMore, Delete, DragHandle, InfoOutlined } from '@mui/icons-material';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import CommonCard from '../components/common_card';
import { TypographyBold } from '../style/typography';
import { CustomControlledInput } from "./CustomControlledInput";

const WorkList = ({
    workList,
    workCategories,
    control,
    expandedWork,
    handleEditClick,
    handleCancelEdit,
    handleDeleteClick,
    handleEditSubmit,
    openDialog,
    title,
    droppableId,
    isDisabled
}) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    return (
        <Grid size={{ xs: 12 }}>
            <CommonCard
                child={
                    <Grid container spacing={3} sx={{ padding: 3 }}>
                        <Grid size={{ xs: 12 }}>
                            <TypographyBold sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Tooltip
                                    title="＝をドラッグ&ドロップで並べ替えができます"
                                    arrow
                                    open={tooltipOpen}
                                    onClose={() => setTooltipOpen(false)}
                                    PopperProps={{
                                        placement: 'bottom-end'
                                    }}
                                >
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setTooltipOpen(prev => !prev);
                                        }}
                                    >
                                        <InfoOutlined fontSize="medium" sx={{ cursor: "pointer", color: "#0A7CB7" }} />
                                    </IconButton>
                                </Tooltip>
                                {title}
                            </TypographyBold>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Droppable droppableId={droppableId}>
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {Array.isArray(workList) && workList.map((work, index) => (
                                            <Draggable key={work.uuid} draggableId={String(work.uuid)} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        style={{ ...provided.draggableProps.style, marginBottom: '8px' }}
                                                    >
                                                        <Accordion
                                                            expanded={expandedWork === work.uuid}
                                                            onChange={() => {
                                                                if (expandedWork === work.uuid) {
                                                                    handleCancelEdit();
                                                                } else {
                                                                    handleEditClick(work);
                                                                }
                                                            }}
                                                            sx={{ backgroundColor: snapshot.isDragging ? '#f0f0f0' : 'inherit' }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMore />}
                                                                aria-controls={`work-content-${work.uuid}`}
                                                                id={`work-header-${work.uuid}`}
                                                                sx={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <div {...provided.dragHandleProps} style={{ marginRight: '8px', cursor: 'grab', display: 'flex', alignItems: 'center' }}>
                                                                    <DragHandle color="action" />
                                                                </div>
                                                                <div>
                                                                    <Typography variant="h6" component="div">{work.name}</Typography>
                                                                </div>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <Grid container spacing={2} sx={{ paddingTop: 3 }}>
                                                                    {/* 業務名 */}
                                                                    <Grid size={{ xs: 12, md: 6 }}>
                                                                        <CustomControlledInput
                                                                            name="editWork.name"
                                                                            control={control}
                                                                            label="業務名"
                                                                            variant="outlined"
                                                                            inputProps={{ maxLength: 100 }}
                                                                            disabled={isDisabled}
                                                                        />
                                                                    </Grid>
                                                                    {/* 業務カテゴリ */}
                                                                    <Grid size={{ xs: 12, md: 6 }}>
                                                                        <CustomControlledInput
                                                                            name="editWork.category"
                                                                            control={control}
                                                                            label="業務カテゴリ"
                                                                            type="select"
                                                                            multiple={false}
                                                                            options={workCategories.map((c) => ({
                                                                                value: c.value,
                                                                                label: c.label
                                                                            }))}
                                                                            disabled={isDisabled}
                                                                        />
                                                                    </Grid>
                                                                    {/* ボタン群 */}
                                                                    <Grid
                                                                        size={{ xs: 12 }}
                                                                        display="flex"
                                                                        justifyContent="space-between"
                                                                        gap={2}
                                                                        sx={{ mt: 2 }}
                                                                    >
                                                                        <Button variant="outlined" color="error" onClick={() => handleDeleteClick(work)} startIcon={<Delete />} disabled={isDisabled}>削除</Button>
                                                                        <div style={{ display: 'flex', gap: '8px' }}>
                                                                            <Button variant="outlined" onClick={handleCancelEdit} disabled={isDisabled}>
                                                                                キャンセル
                                                                            </Button>
                                                                            <Button
                                                                                variant="contained"
                                                                                onClick={handleEditSubmit(
                                                                                    (data) => { openDialog('save', data.editWork); }
                                                                                )}
                                                                                sx={{
                                                                                    backgroundColor: 'rgba(124, 183, 10, 1.0)',
                                                                                    '&:hover': { backgroundColor: 'rgba(124, 183, 10, 0.8)' }
                                                                                }}
                                                                                disabled={isDisabled}
                                                                            >
                                                                                保存
                                                                            </Button>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                    </Grid>
                }
            />
        </Grid>
    );
};

export default WorkList;